// extracted by mini-css-extract-plugin
export default {"cls1":"suz0mUNjnpHK7CcpyRUg","cls2":"zUlCtXuzrneOABmCtd3V suz0mUNjnpHK7CcpyRUg"};